import React, { useState, useEffect, useRef } from 'react';
import PropTypes from "prop-types";
import { Modal, Button } from 'semantic-ui-react';
import GridPanel from '../GridPanel';
import CustomerDropDown from '../shared/CustomerDropDown';
import _ from 'lodash'
import { GetCustomers, UpdateCustomers } from '../../api/services/crm';
import { onSuccess, onError, onWarning } from '../shared/messages'
import { useLoader } from '../../hooks/useLoader';


const CustomerChannelMapping = (prop) => {
    const loader = useLoader()
    const CustomerVM = prop.customer ? prop.customer : { ID: 0 };
    const [visibleIcon, setVisibleIcon] = useState(false);
    const [customer, setCustomer] = useState(CustomerVM);
    const [open, setOpen] = useState(false)
    const [chanels, setChanels] = useState([])
    const iconEl = useRef(null);

    useEffect(() => {
        {
        customer && customer.Id && (async () => {
            const customerWithUpdatedChanels = await GetCustomers({
                ID: customer.Id,
                IncludeCustomerAsChannels: true,
                IncludeCustomerAsMappedByOtherChanels: true
            });
            if (customerWithUpdatedChanels && customerWithUpdatedChanels.Customer && customerWithUpdatedChanels.Customer.length) {
                setCustomer(customer => { return { ...customer, CustomerAsMappedByOtherChanels: customerWithUpdatedChanels.Customer[0].CustomerAsMappedByOtherChanels } })
            }
        })()

            if (typeof customer === 'object' && customer !== null) {
                if (!customer.ExternalChannelID) {
                    setVisibleIcon(true);
                }
                else {
                    setVisibleIcon(false);
                }
            }
        }
        
    }, [customer.Id])

    useEffect(() => {
        (async () => {

            const customers = await GetCustomers({
                GetOnlyCustomerArray: true,
                IncludeExternalChanelsOnly: true
            });
            customers.unshift({ ID: 0, Name: " " })
            setChanels(customers);


        })()
    }, [])
    // set visibility on menu icon for popup open
    // customerchannelmappingsideicon - the id of HTML element on menu 
    useEffect(() => {
        let parent = document.querySelector("#customerchannelmappingsideicon")
        if (parent) {
            parent.style.display = visibleIcon ? "" : "none"
        }
    }, [visibleIcon])

    // create connection with external functions on windows
    useEffect(() => {
        if (!window.$exinterface) {
            window.$exinterface = {};
        }
        window.$exinterface.setCustomerData = (customerExternal) => {
            setCustomer(customerExternal);
            if (!customerExternal.ExternalChannelID) {
                setVisibleIcon(true);
            }
            else {
                setVisibleIcon(false);
            }

        }
        window.$exinterface.openCustomerChannelMapping = (customerExternal) => {
            setCustomer(customerExternal)
            setOpen(true)
        }
    }, [])

    const onClickOpen = () => {
        // Check if should open or show message
        if (customer && customer.Id != undefined) {
            setOpen(true)
        } else {
            window.optima.UI.messages.warning(window.optima.resourceManager.messages.ReservationLeftMenuFunctuanalityAvailableOnlyForSavedReservations);
        }
    }
    const onSave = () => {

        if(!customer.Id){
            onWarning({ "error": { "ErrorMessage": "Please save customer before add mapping" } });
            return;
        }

        (async () => {
            try {
                loader(true)
                const res = await UpdateCustomers({ request: customer });
                const customerAsMappedByOtherChanelsItems = res.CustomerAsMappedByOtherChanels.map(item => {
                    const chanelName = _.find(chanels, ["ID", item.ChannelId]).Name;
                    return {
                        ID: item.Id,
                        CustomerId: item.CustomerId,
                        ChannelId: item.ChannelId,
                        MappingCode: item.MappingCode,
                        ChanelName: chanelName
                    }
                });
                let updatedCustomer = { ...customer, CustomerAsMappedByOtherChanels: customerAsMappedByOtherChanelsItems };

                setCustomer(updatedCustomer);
                onSuccess();
                loader(false);
            }
            catch (err) {
                loader(false);
                onError(err);
            }
        })();


    }

    const onUpdate = (added, changed, deleted) => {
        if (added){
            customer.CustomerAsMappedByOtherChanels = [...customer.CustomerAsMappedByOtherChanels, ...added]
        }

        if (deleted) {
            customer.CustomerAsMappedByOtherChanels = customer.CustomerAsMappedByOtherChanels.filter((x, i)=>!deleted.includes(i))
        }

        if (changed) {
            _.forEach(changed, (value, key) => {
                if (value) {
                    _.forEach(value, (newValue, prop) => {

                        switch (prop) {
                            case "MappingCode": {
                                customer.CustomerAsMappedByOtherChanels[key][prop] = newValue;
                                break;
                            }
                            case "ChannelId": {
                                customer.CustomerAsMappedByOtherChanels[key][prop] = newValue;
                                const item = _.find(chanels, ["ID", newValue]);
                                if (item) {
                                    customer.CustomerAsMappedByOtherChanels[key]["ChanelName"] = item.Name;
                                }
                                break;
                            }

                            default: {
                                customer.CustomerAsMappedByOtherChanels[key][prop] = newValue;
                            }

                        }
                    })
                }
            })

            setCustomer({...customer});
        }
    }
   

    const gridOptions = {
        columns: [
            {
                displayField: 'ChanelName',
                name: 'ChannelId',
                title: 'Chanel Name',
                editor: <CustomerDropDown data={chanels} basic />
            },
            { name: 'MappingCode', title: 'External Code' }
        ],
        editable: {
            allowAdd: true,
            allowDelete: true,
            allowEdit: true
        }
    }

    if (visibleIcon) {
        return (
            <Modal
                size="small"
                onClose={() => setOpen(false)}
                open={open}
                trigger={
                    <span
                        className="icon-letter-envelope"
                        tooltip-animation='true'
                        tooltip-placement='top'
                        uib-tooltip="Chanel Mapping"
                        onClick={() => onClickOpen()}>

                    </span> }>
                <Modal.Header>Customer Channel Mapping</Modal.Header>
                <Modal.Content style={{ minHeight: "400px", display: "flex", flexDirection: "column" }}>
                    <GridPanel options={gridOptions} data={customer.CustomerAsMappedByOtherChanels} onUpdate={onUpdate} />
                </Modal.Content>
                <Modal.Actions>
                    <Button positive onClick={() => onSave()}>Save</Button>
                    <Button negative onClick={() => setOpen(false)}>Close</Button>
                </Modal.Actions>
            </Modal >

        )
    } else return (
        <div ref={iconEl}></div>
    )

}

CustomerChannelMapping.propTypes = {
    Customer: PropTypes.object
}

export default CustomerChannelMapping